import {ZodSchema} from 'zod';

export type BaseQueryExtraOptions = {
  requestSchema?: ZodSchema;
  responseSchema?: ZodSchema;
  maxRetries?: number;
};
